import * as angular from 'angular';

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name pkpMinPublishedShippers
     * @memberof app
     *
     * @restrict A
     *
     * @description
     *
     * Validates if the following specification is true:
     * "A Trader List must at least contain 3 published Shippers.
     * There is no restriction for the minimum number of non published Shippers
     * (that are added in addition to the 3 published shippers).
     * This condition is validated, whenever the trader list is modified."
     * (copied from BTCPKP-4699)
     *
     * Published shippers have a name property, so the validation checks, if enough
     * items of the array given by ng-model have this property.
     *
     * BTCPKP-8176: Only counter-parties count. The own shipper EIC must be ignored.
     *
     * @author somarten.btc
     */
    angular
        .module('app')
        .directive(
            'pkpMinPublishedShippersValidator',
            pkpMinPublishedShippersValidator
        );

    function pkpMinPublishedShippersValidator(arrayService) {
        return {
            restrict: 'A',
            scope: false,
            require: 'ngModel',
            link: linkFn
        };

        function linkFn(scope, element, attr, ctrl) {
            ctrl.$validators.pkpMinPublishedShippersValidator = function (
                modelValue
            ) {
                var array = modelValue;
                var requiredProperty = 'name';
                var minimalNumber = attr.minimalNumber;
                var ownEic = attr.ownEic;
                return sufficientNumberOfItemsWithProperty(
                    array,
                    requiredProperty,
                    minimalNumber,
                    ownEic
                );
            };

            scope.$watchCollection(attr.ngModel, function () {
                if (ctrl.$options === null) {
                    ctrl.$options = {};
                }
                ctrl.$options.allowInvalid = true; //prevents array from getting undefined if invalid
                ctrl.$validate();
            });

            function sufficientNumberOfItemsWithProperty(
                array,
                requiredProperty,
                minimalNumber,
                ownEIC
            ) {
                if (!!array) {
                    var counter = 0;
                    for (var i = 0; i < array.length; i++) {
                        var eic =
                            arrayService.getElementInArrayWhereKeyEqualsValue(
                                'id',
                                array,
                                'type',
                                'EIC'
                            );
                        if (
                            angular.isDefined(array[i][requiredProperty]) &&
                            eic !== ownEIC
                        ) {
                            counter++;
                        }
                        if (counter >= minimalNumber) {
                            return true;
                        }
                    }
                }
                return false;
            }
        }
    }
})();
